import Thankyou1 from '../MyComponent/Thankyou';

function Thankyou() {
  return (
    <div>
      <Thankyou1 />
    </div>
  );
}

export default Thankyou;
